<div class="flex flex-col min-h-screen justify-between w-full gap-10 lg:gap-20">
  <div class="relative w-full h-full">
    <div class="sticky z-40 top-0">
      <app-portal-navbar></app-portal-navbar>
    </div>
    <div class="h-full w-full mt-10 md:mt-20">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-portal-footer></app-portal-footer>
</div>
